// Batch 3 M365 strings, merged into gavion.integrations next to batch 6 (see fr.ts).
export const integrationsM365Fr = {
  microsoft: {
    title: "Microsoft 365",
    description:
      "Courriels Outlook, calendrier et réunions Teams depuis votre boîte.",
    connect: "Connecter",
    reconnect: "Reconnecter Microsoft 365",
    disconnect: "Déconnecter",
    confirm_disconnect_title: "Déconnecter Microsoft 365 ?",
    confirm_disconnect_body:
      "La synchronisation s'arrête. Les courriels déjà enregistrés sont conservés.",
    connected_as: "Connecté : %{email}",
    last_sync: "Dernière synchronisation : %{at}",
    never_synced: "Jamais synchronisé",
    status: {
      connected: "Connecté",
      needs_reauth: "Reconnexion requise",
      error: "Erreur",
      disconnected: "Déconnecté",
      none: "Non connecté",
    },
    needs_reauth_help:
      "Votre autorisation Microsoft a expiré ou a été révoquée. Reconnectez-vous pour reprendre la synchronisation.",
    missing_title: "Fonctions indisponibles",
    features: {
      mail_sync: "Synchronisation des courriels",
      send: "Envoi de courriels",
      calendar: "Calendrier Outlook",
      teams_meetings: "Réunions Teams",
      archive: "Archive de boîtes partagées",
    },
    ask_admin: "Demander à l'administrateur d'approuver les autorisations",
    connected_toast: "Microsoft 365 est connecté.",
    disconnected_toast: "Microsoft 365 est déconnecté.",
  },
  signature: {
    title: "Signature courriel",
    hint: "Ajoutée automatiquement aux courriels envoyés depuis le CRM. Le bouton « Image » ajoute votre logo.",
    save: "Enregistrer la signature",
    saved: "Signature enregistrée.",
    add_booking: "Ajouter mon lien de rencontre",
    booking_label: "Réserver une rencontre",
  },
  teams: {
    title: "Microsoft Teams",
    description:
      "Canal où sont publiées les notifications (démos, ventes, résumé quotidien).",
    team: "Équipe",
    channel: "Canal",
    choose_team: "Choisir une équipe",
    choose_channel: "Choisir un canal",
    save: "Enregistrer",
    saved: "Canal Teams enregistré.",
    current: "Publication dans %{team} › %{channel}",
    not_configured: "Aucun canal configuré.",
    poster_hint: "Les messages sont publiés avec votre compte Microsoft.",
    connect_first: "Connectez d'abord votre compte Microsoft 365.",
    webhook: "URL du flux Workflows (secours)",
    webhook_hint: "Utilisée si la publication directe est refusée (403).",
    webhook_save: "Enregistrer l'URL",
    webhook_clear: "Retirer l'URL",
    webhook_saved: "URL de secours enregistrée.",
    webhook_cleared: "URL de secours retirée.",
    webhook_clear_title: "Retirer l'URL de secours ?",
    webhook_clear_body:
      "Si la publication directe est refusée, aucun message ne sera envoyé.",
    webhook_configured: "URL de secours configurée",
    admin_only: "Réservé aux administrateurs.",
  },
  errors: {
    forbidden: "Accès refusé.",
    unauthorized: "Session expirée. Reconnectez-vous.",
    invalid_body: "Requête invalide.",
    microsoft_not_connected: "Microsoft 365 n'est pas connecté.",
    microsoft_needs_reauth: "Reconnectez Microsoft 365.",
    microsoft_account_mismatch:
      "Ce compte Microsoft ne correspond pas à votre adresse Gavion.",
    microsoft_token_invalid: "Jeton Microsoft refusé. Reconnectez-vous.",
    microsoft_app_credentials:
      "L'application Microsoft du CRM est mal configurée. Prévenez l'administrateur.",
    refresh_token_missing:
      "Microsoft n'a pas fourni d'accès hors ligne. Utilisez « Connecter ».",
    invalid_state: "La connexion a expiré. Recommencez.",
    consent_denied: "Autorisation refusée dans Microsoft.",
    suppressed: "Désabonné / ne pas contacter : %{emails}",
    no_consent: "Aucun consentement pour ce destinataire.",
    // GAVION video-campaign: a campaign follow-up (CASL footer and unsubscribe link)
    campaign_single_recipient:
      "Un suivi de campagne part à un seul destinataire, sans copie (son lien de désabonnement lui est propre).",
    unsubscribe_not_configured:
      "Le lien de désabonnement n'est pas configuré. Prévenez l'administrateur.",
    attachments_too_large: "Pièces jointes trop volumineuses",
    graph_throttled: "Réessayez dans un moment.",
    graph_unavailable: "Microsoft ne répond pas. Réessayez dans un moment.",
    idempotency_conflict: "Envoi déjà utilisé par un autre compte.",
    send_in_progress: "Envoi déjà en cours…",
    deal_not_found: "Affaire introuvable.",
    no_owner: "Cette affaire n'a pas de représentant.",
    no_active_demo: "Aucune démo Outlook à modifier.",
    not_reassigned:
      "Cette démo est déjà dans l'Outlook du responsable de l'affaire : utilisez « Modifier la démo ».",
    demo_start_invalid: "Date ou durée invalide.",
    demo_in_past: "La démo est dans le passé.",
    webhook_url_invalid:
      "URL refusée : utilisez l'URL du flux Workflows de Teams.",
    message_gone: "Ce message n'existe plus dans Outlook.",
    attachment_unavailable: "Cette pièce jointe n'est plus disponible.", // GAVION full-email
    not_found: "Introuvable.",
    m365_unavailable: "Microsoft 365 n'est pas encore disponible.",
    m365_not_configured:
      "Microsoft 365 n'est pas encore configuré par l'administrateur.",
    microsoft_consent_missing:
      "Autorisations Microsoft manquantes. Demandez à l'administrateur d'approuver les permissions, puis reconnectez-vous.",
    graph_send_unknown:
      "L'envoi n'a pas pu être confirmé. Vérifiez vos éléments envoyés dans Outlook avant de réessayer.",
    needs_review:
      "Envoi à vérifier : consultez vos éléments envoyés dans Outlook.",
    connect_failed: "La connexion a échoué.",
    unknown: "Une erreur est survenue.",
  },
};
